import React, { ReactNode } from 'react'
import styles from './WContainer.module.sass'

interface Props {
  variant?: 'md' | 'sm' | 'xs' | 'none' | 'fluid'
  className?: string
  children?: ReactNode
}

const WContainer = (props: Props) => {
  const { variant = 'md', className = '', children = null } = props

  return variant === 'none' ? (
    <>{children}</>
  ) : (
    <div className={`${styles.root} ${styles[`root--${variant}`]} ${className}`}>{children}</div>
  )
}

export default WContainer
